var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TheNavigationBar'),_vm._v(" "),_c('TheMain'),_vm._v(" "),_c('TheIntroductionModal',{ref:"modalComponent",on:{"consent":_vm.setVisitCookie}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }